<body>
  <!-- Back Arrow -->
  <button class="back-arrow" (click)="goBack()" title="Back to Login">
    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
    </svg>
  </button>

  <div class="container" style="width: 480px;">
    <div class="logo">
      <img
        src="./../../../../assets/img/bharat-logo.png"
        alt="Kenya Coat of Arms" />
    </div>

    <h1>Change Password</h1>
    <p class="subtitle">Create a secure password for your KEMIS account</p>

    <form [formGroup]="myForm" (ngSubmit)="submit(myForm)">
      <!-- New Password -->
      <div class="form-group">
        <label for="newPassword">New Password</label>
        <div class="input-wrapper">
          <input
            [type]="showNewPassword ? 'text' : 'password'"
            id="newPassword"
            formControlName="password"
            placeholder="Enter your new password"
            (input)="validatePassword()" />
          <button type="button" class="toggle-password" (click)="togglePassword('newPassword')">
            {{ showNewPassword ? 'Hide' : 'Show' }}
          </button>
        </div>
        <div class="text-danger" *ngIf="fc['password'].errors && (fc['password'].touched || fc['password'].dirty)">
          <div *ngIf="fc['password'].errors['required']">New Password is required</div>
          
        </div>
      </div>

      <!-- Password Requirements -->
      <div class="requirements">
        <h3>Password Requirements</h3>
        <div class="req-item" *ngFor="let rule of requirements">
          <span [ngClass]="{'req-icon': true, 'req-valid': rule.valid, 'req-invalid': !rule.valid}">
            {{ rule.valid ? '✓' : '✗' }}
          </span>
          <span>{{ rule.label }}</span>
        </div>
      </div>

      <!-- Confirm Password -->
      <div class="form-group">
        <label for="confirmPassword">Confirm Password</label>
        <div class="input-wrapper">
          <input
            [type]="showConfirmPassword ? 'text' : 'password'"
            id="confirmPassword"
            placeholder="Confirm your password"
            [(ngModel)]="confirmPassword" formControlName="confirmPassword"
            name="confirmPassword"
            (input)="checkFormValidity()" />
          <button type="button" class="toggle-password" (click)="togglePassword('confirmPassword')">
            {{ showConfirmPassword ? 'Hide' : 'Show' }}
          </button>
        </div>
        <div class="text-danger" *ngIf="fc['confirmPassword'].errors && (fc['confirmPassword'].touched || fc['confirmPassword'].dirty)">
          <div *ngIf="fc['confirmPassword'].errors['required']">Confirm Password is required</div>
          <div *ngIf="fc['confirmPassword'].errors['mustMatch']">Passwords do not match.</div>
        </div>
      </div>

      <!-- Submit -->
      <button type="submit" class="submit-btn" [disabled]="!formValid">Update Password</button>
    </form>
  </div>

</body>